import Application from "../../Application";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import { ICourtCase } from "../model/CourtCase";
import { IInvalidatedCaseLawDocument } from "../model/InvalidatedCaseLawDocument";
import { ICaseLawDocumentService } from "../service/CaseLawDocumentService";

export default class UpdateCaseLawDocumentInteractor {
  private application: Application;
  private caseLawDocumentService: ICaseLawDocumentService;

  constructor({ application, caseLawDocumentService }: any) {
    this.application = application;
    this.caseLawDocumentService = caseLawDocumentService;
  }

  async execute(
    item: ICaseLawDocument,
    indexes: number[],
    courtCases?: ICourtCase[],
    invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
  ) {
    return this.caseLawDocumentService.updateCaseLawDocument(
      item,
      indexes,
      courtCases,
      invalidatedCaseLawDocuments
    );
  }
}
